import React from 'react';
import { FileText } from 'lucide-react';
import styles from '../StudyManagement.module.css';

const DataCaptureHeader = () => {
    return (
        <div className={styles.pageHeader}>
            <h1 className={styles.mainTitle}>Data Capture</h1>
            <p className={styles.subtitle}>Electronic Data Capture (EDC) system for clinical data collection</p>
        </div>
    );
};

export default DataCaptureHeader;